import { useQuery } from '@tanstack/react-query';
import { getSignUpEmail } from 'api/resources/signUp';
import { ECacheKeys } from 'cache/CacheKeys';
import type { UseQueryOptions } from '@tanstack/react-query';

export const useGetSignupEmail = (
	submissionGuid: string,
	options?: UseQueryOptions<string | null>
) => {
	const query = useQuery<string | null>({
		queryKey: [ECacheKeys.SignUp, 'email', submissionGuid],
		queryFn: () => getSignUpEmail(submissionGuid),
		refetchInterval: false,
		refetchOnWindowFocus: false,
		...(options || {}),
	});

	return query;
};
